const hostApi = process.env.NODE_ENV === 'development' ? 'https://data.libarts.up.ac.th' : 'https://data.libarts.up.ac.th';
const portApi = process.env.NODE_ENV === 'development' ? '' : '';
const baseURLApi = `${hostApi}${portApi ? `:${portApi}` : ``}/api`;
const baseURLStorage = `${hostApi}${portApi ? `:${portApi}` : ``}/storage/`;
const baseURLReport = `${hostApi}${portApi ? `:${portApi}` : ``}/report`;

const redirectUrl = process.env.NODE_ENV === "development" ? 'https://data.libarts.up.ac.th/admin' : "https://data.libarts.up.ac.th/admin";


/*
const hostApi = process.env.NODE_ENV === 'development' ? 'http://localhost' : 'http://data.libarts.up.ac.th';
const portApi = process.env.NODE_ENV === 'development' ? 8080 : '';
const baseURLApi = `${hostApi}${portApi ? `:${portApi}` : ``}/api`;
const baseURLStorage = `${hostApi}${portApi ? `:${portApi}` : ``}/storage/`;
const baseURLReport = `${hostApi}${portApi ? `:${portApi}` : ``}/report`;

const redirectUrl = process.env.NODE_ENV === "development" ? 'http://localhost:3000/verify-email' : "https://demo.flatlogic.com/vue-material";*/


const tiny = {
    api: '4zx61nqi0bzqu5duaojlj7yr0hkzdqr60rv459g0xafzx3d2',
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount',
        'importcss'
    ],
    toolbar: 'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help'
};


export default {
    light: {
        primary: '#536dfe',
        primaryConst: '#536dfe',
        secondary: '#FF5C93',
        secondaryConst: '#FF5C93',
        error: '#FF4081',
        warning: '#FFC260',
        success: '#3CD4A0',
        successConst: '#3CD4A0',
        info: '#9013FE',
        greyBold: '#4a4a4a',
        greyBoldConst: '#4a4a4a',
        greyMedium: '#6e6e6e',
        greyTint: '#b9b9b9',
        default: '#e0e0e0',
        iconColor: '#FFFFFF',
    },
    dark: {
        primary: '#536dfe',
        primaryConst: '#536dfe',
        secondary: '#FF5C93',
        secondaryConst: '#FF5C93',
        success: '#3CD4A0',
        successConst: '#3CD4A0',
        error: '#FF4081',
        greyMedium: '#bfbfbf',
        greyBold: '#d6d6d6',
        greyBoldConst: '#4a4a4a',
        greyTint: '#9b9b9b',
        default: '#e0e0e0',
    },
    hostApi,
    portApi,
    baseURLApi,
    redirectUrl,
    baseURLStorage,
    baseURLReport,
    tiny,
    isBackend: process.env.VUE_APP_BACKEND,
    remote: 'https://sing-generator-node.herokuapp.com',
    auth: {
        email: '',
        password: '',
    },


};
